import apiClient from "../utils/apiClient";
export const getAllShowroom = async ({ isActive, search, page, pageSize } = {}) => {
  const params = new URLSearchParams();

  if (isActive !== undefined) params.append('isActive', isActive);
  if (search) params.append('search', search);
  if (page) params.append('page', page);
  if (pageSize) params.append('pageSize', pageSize);

  const res = await apiClient.get("/showroom/showrooms", { params });

  return res.data;

};
